import { Sprite } from 'spritejs';

export const loadSpriteSheet = (imagePath, frameWidth, frameHeight, rows, cols) => {
  const image = new Image();
  image.src = imagePath;

  return new Promise((resolve) => {
    image.onload = () => {
      const sprites = [];
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const canvas = document.createElement('canvas');
          canvas.width = frameWidth;
          canvas.height = frameHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(
            image,
            col * frameWidth,
            row * frameHeight,
            frameWidth,
            frameHeight,
            0,
            0,
            frameWidth,
            frameHeight
          );
          sprites.push(canvas.toDataURL());
        }
      }
      resolve(sprites);
    };
  });
};